/* global ResizeObserver */
import ApplicationController from './application_controller'
import { ECHARTS_PIE_COLORS } from 'appConstants'

class StorageReportChartController extends ApplicationController {
  static values = { series: Object, total: Number }

  async connect () {
    const echarts = await import('echarts')
    if (!this.element.isConnected) return

    this._chart = echarts.init(this.element, null, { height: 400 })
    this._resizeObserver = new ResizeObserver(() => this._chart?.resize())
    this._resizeObserver.observe(this.element)
    this._chart.setOption({
      color: ECHARTS_PIE_COLORS,
      title: { text: I18n.t('statistics.storage.chart') },
      tooltip: {
        trigger: 'item',
        formatter: p => `${p.seriesName}: <b>${p.percent.toFixed(1)}%</b>`
      },
      series: [{
        name: I18n.t('statistics.storage.share'),
        type: 'pie',
        data: this._buildSeriesData(),
        label: {
          show: true,
          formatter: p => `${p.name}: ${p.percent.toFixed(1)} %`
        }
      }]
    })
  }

  disconnect () {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
      this._resizeObserver = null
    }
    if (this._chart) {
      this._chart.dispose()
      this._chart = null
    }
  }

  _buildSeriesData () {
    return Object.entries(this.seriesValue).map(([media, share]) => ({
      name: I18n.t(`statistics.storage.media_types.${media}`),
      value: share / this.totalValue
    }))
  }
}

export default StorageReportChartController
